// Constants
import {
	SHOW_TOASTER_MESSAGE,
	SET_IS_LOADING,
	SET_SHOW_STUDENT_DETIALS_IN_MOBILE,
} from "../actions/commonActions";

const initialState = {
	toaster: null,
	isLoading: false,
	showStudentDetailsInMobile: false,
};

const commonReducer = (state = initialState, action) => {
	switch (action.type) {
		case SHOW_TOASTER_MESSAGE:
			return {
				...state,
				toaster: action.payload,
			};
		case SET_IS_LOADING:
			return {
				...state,
				isLoading: action.payload,
			};
		case SET_SHOW_STUDENT_DETIALS_IN_MOBILE:
			return {
				...state,
				showStudentDetailsInMobile: action.payload,
			};
		default:
			return state;
	}
};

export default commonReducer;
